import IFrame from './types';

const initialState: IFrame = {frame: {current: 0}};

export default initialState;
